<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Agendamentos"
            description="Cidadãos agendados para profissionais da APS"
            url="/vinculo-acompanhamento"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-3551"
            pageIdentifier="agendamentos"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.agenda_por_profissional_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.agenda_por_profissional_ajuda || 0
            "
            keyAjudaModalInformacao="agenda_por_profissional_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Agendamentos',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
